import React, { Component } from 'react'
import { connect } from "react-redux";
import { Table } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
   allAcademys,
   allAcademyProgram,
   addAcademyProgram,
   editAcademyProgram,
   statusAcademyProgram,
   deleteacademyProgram
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

function TabContainer({ children }) {
   return (
      <Typography component="div" style={{ padding: 8 * 3 }}>
         {children}
      </Typography>
   );
}

class academy extends Component {

   constructor(props) {
      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         activeIndex: 0,
         name: '',
         adddiv: true,
         editdiv: false,
         eid: '',
         edname: '',
         edstrole: '',
         selectdata: '',
         chkbox: false,
         addchkbox: false,
         academylist: [],
         programname: '',
      };
      this.addHandleSubmit = this.addHandleSubmit.bind(this);
      this.deleteacademyProgram = this.deleteacademyProgram.bind(this);
      this.editAcademyProgram = this.editAcademyProgram.bind(this);
      this.statusAcademyProgram = this.statusAcademyProgram.bind(this);
      this.editHandleSubmit = this.editHandleSubmit.bind(this);
      this.onBackSection = this.onBackSection.bind(this);
   }

   UNSAFE_componentWillMount() {
      this.props.allAcademyProgram();
      this.props.allAcademys();
      console.log(this.props.allAcademyProgram(), "hsdghsgdsyahg")
   }

   addHandleSubmit(event) {
      event.preventDefault();
      const { selectdata, name } = this.state;
      const academyAsString = selectdata.toString();
      this.props.addAcademyProgram(name, academyAsString)
         .then((data) => {
            if (data.status === 1) {
               setTimeout(this.onBackSection());
            }
         })
         .catch((error) => {
            console.log(error)
         });
   }

   // deleteacademyProgram(academyid) {
   //    if (window.confirm('Are you sure to delete this Academy?')) {
   //       this.props.deleteacademyProgram(academyid);
   //    }
   // }

   deleteacademyProgram(academyid) {
      this.id = academyid;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {

      if (popupResponse) {
         this.props.deleteacademyProgram(this.id);
         this.data = ""
      }
   }

   editAcademyProgram(rawdata) {
      if (rawdata.xrl_stdrole === 1) {
         this.setState({ chkbox: true });
      } else {
         this.setState({ chkbox: false });
      }
      this.setState({
         eid: rawdata.aapID,
         edname: rawdata.aap_name,
         selectdata: rawdata.aad_name,
         adddiv: false,
         editdiv: true
      });
   }

   editHandleSubmit(event) {
      event.preventDefault();
      const selectedAcademy = this.props.academylists.find(
         academy => academy.aad_name === this.state.selectdata
      );
      if (selectedAcademy) {
         this.props.editAcademyProgram(
            this.state.edname,
            this.state.eid,
            selectedAcademy.aadID
         ).then((data) => {
            if (data.status === 1) {
               setTimeout(this.onBackSection, 6000);
            }
         });
      }
   }

   statusAcademyProgram(id, status) {
      this.props.statusAcademyProgram(id, status);
   }

   onBackSection() {
      this.setState({
         name: '',
         selectdata: '',
         adddiv: true,
         editdiv: false,
         pgadddiv: true,
         pgeditdiv: false,
         pginadddiv: true,
         pgineditdiv: false,
      });
   }

   handleChange(value) {
      this.setState({ activeIndex: value });
   }

   render() {
      const { match, academyprogramlists, loading } = this.props;
      const { academylists } = this.props;
      const academyMap = {};
      academylists.forEach(academy => {
         academyMap[academy.aadID] = academy.aad_name;
      });
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Academy Program| {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.academyprogramsheading" />} match={match} />
            <RctCollapsibleCard >
               {this.state.activeIndex === 0 &&
                  <TabContainer>
                     <div className="row">
                        <div className="col-sm-12 col-lg-8">
                           <RctCollapsibleCard heading="List">
                              <div className="table-responsive">
                                 <Table hover bordered striped>
                                    <thead>
                                       <tr className="bg-primary text-white">
                                          <th>Sl.No</th>
                                          <th>Name</th>
                                          <th>Action</th>
                                       </tr>
                                    </thead>
                                    <tbody>
                                       {academyprogramlists.map((acdyval, idx) => (
                                          <tr key={idx}>
                                             <td>{idx + 1}</td>
                                             <td>{acdyval.aap_name}</td>
                                             <td>
                                                {acdyval.aap_status == 1 ? (
                                                   <a herf="" onClick={() => this.statusAcademyProgram(acdyval.aapID, 0)}><span className="badge badge-info" >Active</span></a>
                                                ) : (
                                                   <a herf="" onClick={() => this.statusAcademyProgram(acdyval.aapID, 1)}><span className="badge badge-danger" >Inactive</span></a>
                                                )}
                                                <IconButton className="text-info" aria-label="edit" onClick={() => this.editAcademyProgram(acdyval)}><EditOutlinedIcon/></IconButton>
                                                <IconButton className="text-danger" aria-label="Delete" onClick={() => this.deleteacademyProgram(acdyval.aapID)}><DeleteOutlineOutlinedIcon/></IconButton>
                                             </td>
                                          </tr>
                                       ))}

                                    </tbody>
                                 </Table>
                              </div>
                           </RctCollapsibleCard>
                        </div>
                        {this.state.adddiv && (
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Add Academy">
                                 <form autoComplete="off" onSubmit={this.addHandleSubmit}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <FormControl fullWidth>
                                                <InputLabel htmlFor="select-academy">Select Academy</InputLabel>
                                                <Select
                                                   value={this.state.selectdata}
                                                   onChange={evt => this.setState({ selectdata: evt.target.value })}
                                                   inputProps={{ name: 'academy' }}
                                                >
                                                   <MenuItem value=""><em>None</em></MenuItem>
                                                   {academylists.map((acdyval, idx) => (
                                                      <MenuItem key={acdyval.aadID} value={acdyval.aadID}>
                                                         {acdyval.aad_name}
                                                      </MenuItem>
                                                   ))}
                                                </Select>
                                             </FormControl>

                                          </div>
                                          <div className="form-group">

                                             <TextField
                                                id="program-name"
                                                fullWidth
                                                label="Program Name"
                                                value={this.state.name}
                                                onChange={evt => this.setState({ name: evt.target.value })}
                                             />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        )}
                        {this.state.editdiv &&
                           <div className="col-sm-6 col-lg-4">
                              <RctCollapsibleCard heading="Edit Academy">
                                 <form autoComplete="off" onSubmit={this.editHandleSubmit}>
                                    <div className="row">
                                       <div className="col-sm-12 col-lg-6 col-xl-12">
                                          <div className="form-group">
                                             <FormControl fullWidth>
                                                <InputLabel htmlFor="select-academy">Select Academy</InputLabel>
                                                <Select
                                                   value={this.state.selectdata}
                                                   onChange={evt => this.setState({ selectdata: evt.target.value })}
                                                   inputProps={{ name: 'academy' }}
                                                >
                                                   <MenuItem value=""><em>None</em></MenuItem>
                                                   {academylists.map((acdyval, idx) => (
                                                      <MenuItem key={acdyval.aadID} value={acdyval.aad_name}>
                                                         {acdyval.aad_name}
                                                      </MenuItem>
                                                   ))}
                                                </Select>
                                             </FormControl>
                                          </div>
                                          <div className="form-group">
                                             <TextField id="name" fullWidth label="Name" required value={this.state.edname} onChange={evt => this.setState({ edname: evt.target.value })} />
                                          </div>
                                          <div className="form-group">
                                             <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                             <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackSection} value="Back" />

                                          </div>
                                       </div>
                                    </div>
                                 </form>
                              </RctCollapsibleCard>
                           </div>
                        }
                         <ConfirmationDialog
                  ref={this.confirmationDialog}
                  onConfirm={(res) => this.deleteDataPermanent(res)}
                  data={'Academy Program'}
               />
                     </div>
                  </TabContainer>}
            </RctCollapsibleCard>
         </div>
      )
   }
}

const mapStateToProps = (state) => {
   const { academyprogram, academy } = state;
   const { academylists } = academy;
   const { academyprogramlists, loading } = academyprogram;
   return { academyprogramlists, academylists, loading };
};


export default connect(mapStateToProps, {
   allAcademyProgram,
   addAcademyProgram,
   editAcademyProgram,
   statusAcademyProgram,
   deleteacademyProgram,
   allAcademys
})(academy); 